// Generated types for ThreadTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from './llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from './llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ThreadTaskReadAPI extends LLMTaskReadAPI {
}

export interface ThreadTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ThreadTaskReadAPISchema: z.ZodType<ThreadTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const ThreadTaskWriteAPISchema: z.ZodType<ThreadTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
